export default class InputNumber {
    constructor(element) {
        this.field = element;
        this.quantity = this.field.querySelector('.quantity')
        this.minusButton = this.field.querySelector('.quantity-minus')
        this.plusButton = this.field.querySelector('.quantity-plus')

        // Clicks minus button
        this.minusButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleMinusClick();
        })

        // Clicks plus button
        this.plusButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.handlePlusClick();
        })
    }

    handleMinusClick() {
        if (parseInt(this.quantity.value) > 1) {
            this.quantity.value = parseInt(this.quantity.value) - 1;
            this.quantity.dispatchEvent(new Event('change'));
        }

        if (this.quantity.classList.contains("ajax-link")) {
            this.updateSubmitButton(this.quantity.value);
        }
    }

    handlePlusClick() {
        this.quantity.value = parseInt(this.quantity.value) + 1;
        this.quantity.dispatchEvent(new Event('change'));

        if (this.quantity.classList.contains("ajax-link")) {
            this.updateSubmitButton(this.quantity.value);
        }
    }

    updateSubmitButton(value) {
        const button = document.querySelector('.ajax-button')
        button.setAttribute('data-quantity', value);
    }
}